<script>
/**
 * Widgets common component data.
 * Comes in handy when relying on query params : Call setQueryParams(params)
 * when trying to change query params for this specific widget and getQueryParams
 * to retrieve them.
 *
 * @vue-prop {Object} widget - The widget object as in the DB
 * @vue-prop {Boolean} editable - Whether the widget is in an editable state
 * @vue-prop {Boolean} [cfgTemplateEdition=false] - Widget being editedin teh config, thus not by a specific team
 *                                       but rather as a page template.
 *
 * @vue-event {Object} save - Needs to be emitted when the user is done editing.
 *   Must provide the widget's data to save as an object that will then be passed as props
 * @vue-event {Object} configChange - Emit a change of the widget option.
 * @vue-event {Boolean} setMaxZIndex - Emit to put this widget above all the others.
 * @vue-event {} updateConfigOptions - Emit to update the options of the widget if they are displayed.
 *                                     No effect if the widget's options aren't displayed.
 *
 *
 *
 * Method refresh - Will be called when the page is loaded
 * Method sizeChanged - Will be called when the widget has been resized
 * Method configEditionStart - Called once the config panel is displayed
 */

import { isEqual } from 'lodash';

export default {

  props: {
    widget: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    resizing: Boolean,
    dragging: Boolean,
    container: {
      type: HTMLElement,
      default: null,
    },
    cfgTemplateEdition: Boolean,
  },

  data() {
    return {
      // Instance of the WidgetConfigPanel component
      configPanel: null,
    };
  },

  computed: {
    queryParamPrefix() {
      return `widget${this.widget.id}`;
    },
    config: () => {},
    queryParams() {
      const { query } = this.$route;
      const params = {};
      Object.keys(query).forEach((key) => {
        const k = key.split(this.queryParamPrefix)[1];
        if (k) {
          params[k] = query[key];
        }
      });
      return params;
    },
  },

  methods: {
    refresh() {
    },
    sizeChanged() {
    },
    resize() {
    },
    mixinConfigEditionStart(configPanel) {
      // Mixin method execution
      this.configPanel = configPanel;
      // Refresh height of the content of the panel
      this.$nextTick(configPanel.expandConfigSettings);
      // Component method execution
      this.configEditionStart(configPanel);
    },
    /* eslint-disable-next-line no-unused-vars */
    configEditionStart(configPanel) {
    },
    /** Set widget-specific params */
    setQueryParams(params) {
      const query = Object.assign({}, this.$route.query);
      /* eslint-disable-next-line */
      for (const key in params) {
        query[`${this.queryParamPrefix}${key}`] = params[key];
      }
      query.widgetToUpdate = String(this.widget.id);
      if (!isEqual(query, this.$route.query)) {
        this.$router.replace({ query });
      }
    },
    /** Retrieve params as a usable object */
    getQueryParams() {
      const { query } = this.$route;
      const params = {};
      /* eslint-disable-next-line */
      for (const key in query) {
        params[key.split(this.queryParamPrefix)[1]] = query[key];
      }
      return params;
    },
    setMaxZIndex(setMax) {
      this.$emit('setMaxZIndex', !!setMax);
    },
    userLoaded() {
    },
  },
};
</script>
